import React from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';

import Iconify from '../../../theme/iconify/iconify';

function Prompt({ prompt, setPrompt, sendMessage, model }) {
    const { t } = useTranslation();

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (!event.shiftKey) {
                event.preventDefault();
                sendMessage();
            }
        }
    }

    return (
        <>
            <TextField
                id='mISLec_chat_prompt'
                placeholder={t('chat.prompt.inputs.prompt.placeholder')}
                variant='outlined'
                value={prompt}
                maxRows={5}
                multiline
                onChange={(e) => setPrompt(e.target.value)}
                onKeyDown={handleKeyDown}
                fullWidth
                sx={{
                    pl: 0
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start'>
                            {model}
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position='start'>
                            {prompt === '' ?
                                <IconButton disabled={prompt === '' ? true : false} edge='end'>
                                    <Iconify icon='eva:arrow-upward-fill' />
                                </IconButton>
                                :
                                <Tooltip title={t('chat.prompt.tooltips.send')} arrow>
                                    <IconButton disabled={prompt === '' ? true : false} onClick={() => sendMessage()} edge='end' sx={{ borderRadius: '8px' }}>
                                        <Iconify icon='eva:arrow-upward-fill' />
                                    </IconButton>
                                </Tooltip>
                            }
                        </InputAdornment>
                    ),
                    classes: {
                        root: 'mISLec_chat_prompt_root'
                    }
                }}
            />
            <Typography variant='body1' sx={{ textAlign: 'center', fontSize: '12px', width: '100%', pt: 1 }}>
                {t('chat.prompt.disclaimer')}
            </Typography>
        </>
    );
}

export default Prompt;